import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ToggleTapToBorrowMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
  feature_tap_to_borrow_enabled: Types.Scalars['Boolean'];
  feature_tap_to_borrow_two_tap_flow: Types.Scalars['Boolean'];
}>;


export type ToggleTapToBorrowMutation = { __typename?: 'Mutation', adminUpdateUser?: { __typename?: 'User', id: string, feature_tap_to_borrow_enabled: boolean, feature_tap_to_borrow_two_tap_flow: boolean } | null };


export const ToggleTapToBorrowDocument = gql`
    mutation ToggleTapToBorrow($id: ID!, $feature_tap_to_borrow_enabled: Boolean!, $feature_tap_to_borrow_two_tap_flow: Boolean!) {
  adminUpdateUser(
    id: $id
    item: {feature_tap_to_borrow_enabled: $feature_tap_to_borrow_enabled, feature_tap_to_borrow_two_tap_flow: $feature_tap_to_borrow_two_tap_flow}
  ) {
    id
    feature_tap_to_borrow_enabled
    feature_tap_to_borrow_two_tap_flow
  }
}
    `;
export type ToggleTapToBorrowMutationFn = Apollo.MutationFunction<ToggleTapToBorrowMutation, ToggleTapToBorrowMutationVariables>;

/**
 * __useToggleTapToBorrowMutation__
 *
 * To run a mutation, you first call `useToggleTapToBorrowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleTapToBorrowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleTapToBorrowMutation, { data, loading, error }] = useToggleTapToBorrowMutation({
 *   variables: {
 *      id: // value for 'id'
 *      feature_tap_to_borrow_enabled: // value for 'feature_tap_to_borrow_enabled'
 *      feature_tap_to_borrow_two_tap_flow: // value for 'feature_tap_to_borrow_two_tap_flow'
 *   },
 * });
 */
export function useToggleTapToBorrowMutation(baseOptions?: Apollo.MutationHookOptions<ToggleTapToBorrowMutation, ToggleTapToBorrowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleTapToBorrowMutation, ToggleTapToBorrowMutationVariables>(ToggleTapToBorrowDocument, options);
      }
export type ToggleTapToBorrowMutationHookResult = ReturnType<typeof useToggleTapToBorrowMutation>;
export type ToggleTapToBorrowMutationResult = Apollo.MutationResult<ToggleTapToBorrowMutation>;
export type ToggleTapToBorrowMutationOptions = Apollo.BaseMutationOptions<ToggleTapToBorrowMutation, ToggleTapToBorrowMutationVariables>;